import React from 'react';
import styled from '@emotion/styled';
import classnames from 'classnames/bind';
import styles from './styles.sass';
import { FieldRadioToggleProps } from './types';

const cx = classnames.bind(styles);

const Wrapper = styled.div`
  display: flex;
`;

/**
 * @deprecated Use  Anchor-ds's FieldRadioToggle instead
 * https://sites.spotify.net/s/%40spotify-internal-anchor-ds/?path=/story/encore-forms-overview--page
 */
const FieldRadioToggle = React.forwardRef(
  (
    {
      label,
      name,
      options,
      disabled,
      onChange,
      value,
      containerClassName,
      ...rest
    }: FieldRadioToggleProps,
    ref: React.Ref<HTMLInputElement>
  ) => (
    <fieldset className={containerClassName}>
      {label && <legend className={styles.legend}>{label}</legend>}
      <Wrapper>
        {options.map((option, index) => {
          const { value: optionValue, label: optionLabel } = option;
          const inputId = `${name}_${index}`;
          const lastIndex = options.length - 1;
          const isSelected = value === optionValue;

          return (
            <label
              key={`${optionValue}-radio-option`}
              htmlFor={inputId}
              data-cy={inputId}
              className={cx({
                option: true,
                firstOption: index === 0,
                lastOption: index === lastIndex,
                selected: isSelected,
                optionDisabled: disabled,
                selectedDisabled: isSelected && disabled,
              })}
            >
              {optionLabel}
              <input
                {...rest}
                ref={ref}
                className={cx({
                  input: true,
                })}
                id={inputId}
                name={name}
                onChange={disabled ? () => null : onChange}
                value={optionValue}
                type="radio"
                checked={isSelected}
              />
            </label>
          );
        })}
      </Wrapper>
    </fieldset>
  )
);

export { FieldRadioToggle };
export { ControlledFieldRadioToggle } from './ControlledFieldRadioToggle';
